<template>
  <div class="welcome-container">
    <!-- 筛选条件 -->
    <div class="search">
      <div style="display: flex; align-items: center; flex-wrap: wrap; gap: 12px;">
        <span style="color: #606266; font-size: 14px;">赛季</span>
        <!-- <el-radio-group v-model="periodType" size="small" @change="handlePeriodChange">
          <el-radio-button label="year">年度</el-radio-button>
          <el-radio-button label="quarter">季度</el-radio-button>
          <el-radio-button label="month">月度</el-radio-button>
        </el-radio-group> -->
        <el-select
          v-if="periodType === 'year'"
          v-model="selectedYear"
          placeholder="请选择年份"
          style="width: 140px;"
          size="small"
          @change="getData"
        >
          <el-option v-for="y in yearOptions" :key="y" :label="y + '年'" :value="y"></el-option>
        </el-select>
        <el-select
          v-if="periodType === 'quarter'"
          v-model="selectedYear"
          placeholder="请选择年份"
          style="width: 140px; margin-left: 8px;"
          size="small"
          @change="getData"
        >
          <el-option v-for="y in yearOptions" :key="y" :label="y + '年'" :value="y"></el-option>
        </el-select>
        <el-select
          v-if="periodType === 'quarter'"
          v-model="selectedQuarter"
          placeholder="请选择季度"
          style="width: 120px;"
          size="small"
          @change="getData"
        >
          <el-option label="Q1" value="Q1"></el-option>
          <el-option label="Q2" value="Q2"></el-option>
          <el-option label="Q3" value="Q3"></el-option>
          <el-option label="Q4" value="Q4"></el-option>
        </el-select>
        <el-select
          v-if="periodType === 'month'"
          v-model="selectedYear"
          placeholder="请选择年份"
          style="width: 140px; margin-left: 8px;"
          size="small"
          @change="getData"
        >
          <el-option v-for="y in yearOptions" :key="y" :label="y + '年'" :value="y"></el-option>
        </el-select>
        <el-select
          v-if="periodType === 'month'"
          v-model="selectedMonth"
          placeholder="请选择月份"
          style="width: 120px;"
          size="small"
          @change="getData"
        >
          <el-option v-for="m in 12" :key="m" :label="m + '月'" :value="m"></el-option>
        </el-select>
        <span style="color: #606266; font-size: 14px; margin-left: 8px;">销售人员</span>
        <el-select
          v-model="selectedPerson"
          placeholder="请选择人员"
          style="width: 140px;"
          size="small"
          @change="getData"
        >
          <el-option
            v-for="p in personList"
            :key="p.id"
            :label="p.name"
            :value="p.id"
          ></el-option>
        </el-select>
      </div>
    </div>

    <!-- 个人业绩概览卡片 -->
    <el-row :gutter="20" style="margin-bottom: 20px;">
      <el-col :span="6" v-for="(card, idx) in summaryCards" :key="idx">
        <div class="panel-item" :class="'panel' + idx">
          <div class="panel-label">{{ card.label }}</div>
          <div class="panel-num">{{ card.value }}</div>
          <div class="panel-sub">
            <span class="sub-rate" :style="{ color: card.rate >= 0 ? '#67C23A' : '#F56C6C' }">
              <i :class="card.rate >= 0 ? 'el-icon-top' : 'el-icon-bottom'"></i>
              {{ Math.abs(card.rate) }}%
            </span>
            <span class="sub-text">环比{{ card.rate >= 0 ? '增长' : '下降' }}</span>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 个人赛 / 团体赛 报名对比图 -->
    <div class="mycard" style="margin-bottom: 20px;" v-if="false">
      <div class="title222">报名人数对比</div>
      <div class="echarts" id="enrollmentCompareChart"></div>
    </div>

    <!-- 学校转化漏斗 -->
    <el-row :gutter="20" style="margin-bottom: 20px;">
      <el-col :span="12">
        <div class="mycard">
          <div class="title222">学校转化漏斗</div>
          <div class="echarts" id="schoolFunnelChart"></div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="mycard">
          <div class="title222">各阶段转化率</div>
          <div class="echarts" id="conversionRateChart"></div>
        </div>
      </el-col>
    </el-row>

    <!-- 月度趋势折线图 -->
    <div class="mycard" style="margin-bottom: 20px;">
      <div class="title222">
        {{ periodType === 'year' ? selectedYear + '年' : periodType === 'quarter' ? selectedYear + '年 ' + selectedQuarter : selectedYear + '年 ' + selectedMonth + '月' }}业绩趋势
      </div>
      <div class="echarts" id="trendLineChart"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'salesPerformanceDashboard',
  data () {
    return {
      periodType: 'year',
      selectedYear: new Date().getFullYear(),
      selectedQuarter: 'Q1',
      selectedMonth: new Date().getMonth() + 1,
      selectedPerson: '1',
      yearOptions: [
        '2023~2024', '2024~2025', '2025~2026'
      ],
      personList: [
        { id: '1', name: '张三' },
        { id: '2', name: '李四' },
        { id: '3', name: '王五' }
      ],
      summaryCards: [],
      enrollmentChart: null,
      funnelChart: null,
      conversionChart: null,
      trendChart: null
    }
  },
  mounted () {
    this.initYearOptions()
    this.$nextTick(() => {
      this.getData()
    })
    window.addEventListener('resize', this.resizeCharts)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeCharts)
    this.destroyCharts()
  },
  methods: {
    initYearOptions () {
      // const currentYear = new Date().getFullYear()
      // this.yearOptions = Array.from({ length: 5 }, (_, i) => currentYear - i)
    },
    handlePeriodChange () {
      this.selectedYear = new Date().getFullYear()
      if (this.periodType === 'quarter') {
        this.selectedQuarter = 'Q1'
      } else if (this.periodType === 'month') {
        this.selectedMonth = new Date().getMonth() + 1
      }
      this.getData()
    },
    getData () {
      this.buildSummaryCards()
      this.$nextTick(() => {
        this.initEnrollmentCompareChart()
        this.initSchoolFunnelChart()
        this.initConversionRateChart()
        this.initTrendLineChart()
      })
    },
    buildSummaryCards () {
      // 模拟数据，按人员、年份、周期返回不同数值
      const seed = this.selectedPerson.charCodeAt(0) + this.selectedYear
      const periodOffset = this.periodType === 'year' ? 0 : this.periodType === 'quarter' ? this.selectedQuarter.charCodeAt(1) : this.selectedMonth
      const mul = (n) => Math.abs((seed * periodOffset * 17 + n * 31) % 100)

      this.summaryCards = [
        {
          label: '学校转化数',
          value: mul(1),
          rate: ((mul(1) % 30) - 5)
        },
        {
          label: '个人赛报名人数',
          value: mul(2) * 10,
          rate: ((mul(2) % 25) - 8)
        },
        {
          label: '团体赛报名人数',
          value: mul(3) * 5,
          rate: ((mul(3) % 30) - 10)
        },
        {
          label: '整体转化率',
          value: (mul(4) % 40 + 20) + '%',
          rate: ((mul(4) % 20) - 5)
        }
      ]
    },
    initEnrollmentCompareChart () {
      const el = document.getElementById('enrollmentCompareChart')
      if (!el) return
      if (this.enrollmentChart) this.enrollmentChart.dispose()
      this.enrollmentChart = echarts.init(el)

      const labels = this.getPeriodLabels()
      const personSeed = this.selectedPerson.charCodeAt(0)
      const yearSeed = this.selectedYear % 100
      const base = (v) => Math.abs((personSeed * yearSeed * v * 13) % 80) + 20

      const option = {
        tooltip: { trigger: 'axis' },
        legend: {
          data: ['个人赛', '团体赛'],
          bottom: 0
        },
        color: ['#409EFF', '#E6A23C'],
        grid: { left: '3%', right: '4%', bottom: '12%', top: '10%', containLabel: true },
        xAxis: {
          type: 'category',
          data: labels,
          axisLabel: { color: '#606266', fontSize: 12 },
          axisLine: { lineStyle: { color: '#DCDFE6' } }
        },
        yAxis: {
          type: 'value',
          name: '报名人数',
          axisLabel: { color: '#606266' },
          splitLine: { lineStyle: { color: '#F0F0F0' } }
        },
        series: [
          {
            name: '个人赛',
            type: 'bar',
            barWidth: 20,
            data: labels.map((_, i) => base(i + 1) * 3),
            label: { show: true, position: 'top', fontSize: 11, color: '#409EFF' },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#409EFF' },
                { offset: 1, color: '#79bbff' }
              ])
            }
          },
          {
            name: '团体赛',
            type: 'bar',
            barWidth: 20,
            data: labels.map((_, i) => base(i + 7) * 2),
            label: { show: true, position: 'top', fontSize: 11, color: '#E6A23C' },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#E6A23C' },
                { offset: 1, color: '#ebb563' }
              ])
            }
          }
        ]
      }
      this.enrollmentChart.setOption(option)
    },
    initSchoolFunnelChart () {
      const el = document.getElementById('schoolFunnelChart')
      if (!el) return
      if (this.funnelChart) this.funnelChart.dispose()
      this.funnelChart = echarts.init(el)

      const personSeed = this.selectedPerson.charCodeAt(0)
      const yearSeed = this.selectedYear % 100
      const base = (v) => Math.abs((personSeed * yearSeed * v * 11) % 60) + 10

      const option = {
        tooltip: { trigger: 'item', formatter: '{b}: {c} 所' },
        color: ['#409EFF', '#36CBCB', '#4EC9B0', '#F56C6C'],
        series: [{
          name: '学校漏斗',
          type: 'funnel',
          left: '5%',
          top: 20,
          bottom: 20,
          width: '55%',
          min: 0,
          minSize: '0%',
          maxSize: '100%',
          sort: 'descending',
          gap: 4,
          label: {
            show: true,
            position: 'inside',
            color: '#fff',
            fontSize: 12,
            formatter: '{b}\n{c}所'
          },
          labelLine: { show: false },
          itemStyle: { borderColor: '#fff', borderWidth: 2 },
          data: [
            { name: '接触学校', value: base(1) + 40 },
            { name: '有意向', value: base(2) + 25 },
            { name: '签约学校', value: base(3) + 12 },
            { name: '实际参赛', value: base(4) }
          ]
        }]
      }
      this.funnelChart.setOption(option)
    },
    initConversionRateChart () {
      const el = document.getElementById('conversionRateChart')
      if (!el) return
      if (this.conversionChart) this.conversionChart.dispose()
      this.conversionChart = echarts.init(el)

      const personSeed = this.selectedPerson.charCodeAt(0)
      const yearSeed = this.selectedYear % 100
      const rate = (v) => ((Math.abs((personSeed * yearSeed * v * 7) % 60) + 20)).toFixed(1)

      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let res = params[0].name + '<br/>'
            params.forEach(p => {
              res += '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + p.color + '"></span>' + p.seriesName + ': ' + p.value + '%<br/>'
            })
            return res
          }
        },
        legend: { data: ['个人赛', '团体赛'], bottom: 0 },
        color: ['#409EFF', '#E6A23C'],
        grid: { left: '3%', right: '4%', bottom: '12%', top: '10%', containLabel: true },
        xAxis: {
          type: 'category',
          data: ['初选', '复选', '城市赛', '总决选'],
          axisLabel: { color: '#606266' },
          axisLine: { lineStyle: { color: '#DCDFE6' } }
        },
        yAxis: {
          type: 'value',
          name: '转化率 %',
          axisLabel: { color: '#606266', formatter: '{value}%' },
          splitLine: { lineStyle: { color: '#F0F0F0' } },
          max: 100
        },
        series: [
          {
            name: '个人赛',
            type: 'line',
            smooth: true,
            data: [rate(1), rate(3), rate(5), rate(7)],
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(64,158,255,0.3)' },
                { offset: 1, color: 'rgba(64,158,255,0)' }
              ])
            },
            itemStyle: { color: '#409EFF' }
          },
          {
            name: '团体赛',
            type: 'line',
            smooth: true,
            data: [rate(2), rate(4), rate(6), rate(8)],
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(230,162,60,0.3)' },
                { offset: 1, color: 'rgba(230,162,60,0)' }
              ])
            },
            itemStyle: { color: '#E6A23C' }
          }
        ]
      }
      this.conversionChart.setOption(option)
    },
    initTrendLineChart () {
      const el = document.getElementById('trendLineChart')
      if (!el) return
      if (this.trendChart) this.trendChart.dispose()
      this.trendChart = echarts.init(el)

      const personSeed = this.selectedPerson.charCodeAt(0)
      const yearSeed = this.selectedYear % 100
      const base = (v) => Math.abs((personSeed * yearSeed * v * 19) % 200) + 50

      const option = {
        tooltip: { trigger: 'axis' },
        legend: { data: ['个人赛', '团体赛', '转化率'], bottom: 0 },
        color: ['#409EFF', '#E6A23C', '#67C23A'],
        grid: { left: '3%', right: '4%', bottom: '12%', top: '10%', containLabel: true },
        xAxis: {
          type: 'category',
          data: this.getPeriodLabels(),
          axisLabel: { color: '#606266' },
          axisLine: { lineStyle: { color: '#DCDFE6' } }
        },
        yAxis: [
          {
            type: 'value',
            name: '人数',
            axisLabel: { color: '#606266' },
            splitLine: { lineStyle: { color: '#F0F0F0' } }
          },
          {
            type: 'value',
            name: '转化率',
            axisLabel: { color: '#606266', formatter: '{value}%' },
            splitLine: { show: false },
            max: 100
          }
        ],
        series: [
          {
            name: '个人赛',
            type: 'line',
            smooth: true,
            yAxisIndex: 0,
            data: this.getPeriodLabels().map((_, i) => base(i + 1) * 4),
            itemStyle: { color: '#409EFF' }
          },
          {
            name: '团体赛',
            type: 'line',
            smooth: true,
            yAxisIndex: 0,
            data: this.getPeriodLabels().map((_, i) => base(i + 5) * 2),
            itemStyle: { color: '#E6A23C' }
          },
          {
            name: '转化率',
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            data: this.getPeriodLabels().map((_, i) => Number((Math.abs((personSeed * yearSeed * (i + 1) * 13) % 45) + 30).toFixed(1))),
            itemStyle: { color: '#67C23A' }
          }
        ]
      }
      this.trendChart.setOption(option)
    },
    getPeriodLabels () {
      if (this.periodType === 'year') {
        return ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
      } else if (this.periodType === 'quarter') {
        const q = this.selectedQuarter
        const quarters = {
          Q1: ['1月', '2月', '3月'],
          Q2: ['4月', '5月', '6月'],
          Q3: ['7月', '8月', '9月'],
          Q4: ['10月', '11月', '12月']
        }
        return quarters[q] || []
      } else {
        // 月度 -> 每周
        return ['第1周', '第2周', '第3周', '第4周']
      }
    },
    resizeCharts () {
      this.enrollmentChart && this.enrollmentChart.resize()
      this.funnelChart && this.funnelChart.resize()
      this.conversionChart && this.conversionChart.resize()
      this.trendChart && this.trendChart.resize()
    },
    destroyCharts () {
      this.enrollmentChart && this.enrollmentChart.dispose()
      this.funnelChart && this.funnelChart.dispose()
      this.conversionChart && this.conversionChart.dispose()
      this.trendChart && this.trendChart.dispose()
    }
  }
}
</script>

<style lang="less" scoped>
.welcome-container {
  padding: 0;
}
.search {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}
.panel-item {
  background: #fff;
  padding: 20px 24px;
  border-radius: 8px;
  border-left: 6px solid;
  margin-bottom: 0;
  transition: box-shadow 0.3s;
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  .panel-label {
    color: #a1a1a1;
    font-size: 14px;
    margin-bottom: 8px;
  }
  .panel-num {
    font-size: 32px;
    font-family: hzgb, "PingFang SC", "Microsoft YaHei", sans-serif;
    color: #303133;
    line-height: 1.2;
    margin-bottom: 8px;
  }
  .panel-sub {
    display: flex;
    align-items: center;
    gap: 6px;
    .sub-rate {
      font-size: 13px;
      font-weight: 600;
    }
    .sub-text {
      font-size: 12px;
      color: #909399;
    }
  }
}
.panel0 { border-left-color: #409EFF; }
.panel1 { border-left-color: #E6A23C; }
.panel2 { border-left-color: #67C23A; }
.panel3 { border-left-color: #F56C6C; }
.mycard {
  background: #fff;
  padding: 20px 24px;
  border-radius: 8px;
  margin-bottom: 0;
  .title222 {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #F0F0F0;
  }
}
.echarts {
  width: 100%;
  height: 300px;
}
</style>
